// extracted by mini-css-extract-plugin
export var progressBar = "_j4-0";
export var progressBarInner = "_j4-1";